'use client';

import cx from 'clsx';

import { DaumPostCode } from './DaumPostCode';

import { CloseIcon } from '~/assets/icons/common';
import type { Address } from './types';

type Props = {
  open?: boolean;
  onClose?: () => void;
  onComplete?: (values: Address) => void;
};
export function AddressSearchModal({ open, onClose, onComplete }: Props) {
  return (
    <div
      className={cx([
        'fixed inset-0 transform translate-y-full transition z-[50] bg-screen-01',
        open && '!translate-y-0',
      ])}
    >
      <header className="relative inset-0 flex h-[52px] items-center justify-end px-16 py-12 shadow-[inset_0_-1px_0_0_theme(colors.secondary.air)]">
        <h1 className="absolute left-1/2 -translate-x-1/2 text-normal typo-title100-semibold">
          주소 검색
        </h1>
        <button type="button" onClick={onClose}>
          <CloseIcon className="w-24" />
        </button>
      </header>
      {/* DaumPostCode가 embed되면서 focus를 가져가기 때문에 open되었을 때 render하도록 변경 */}
      {open && <DaumPostCode onComplete={(values) => onComplete?.(values)} />}
    </div>
  );
}
